











import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetAllUserList } from "@/api/pdTeam";
import { SetPatientDoctor } from "@/api/pdReferral";

@Component
export default class SetCommunity extends AbpBase {
  @Prop() patientId: number; //患者编号
  @Prop() teamId: number; //团队Id
  doctor: any;
  loading: boolean = false;
  data: any = [];
  columns = [
    {
      title: "医生名称",
      key: "userName"
    }
  ];

  created() {
    this.getData();
  }

  async getData() {
    if (this.teamId) {
      this.loading = true;
      let res = await GetAllUserList();
      this.loading = false;
      let userList = res.data;
      if (userList && userList.length != 0) {
        this.data = userList.filter(x => x.teamId == this.teamId);
      }
    }
  }

  handleDoctorChange(row: any) {
    this.doctor = row.userId;
  }

  async submit() {
    if (!this.doctor) {
      this.$Message.error("请选择一个医生");
      return false;
    }
    let payload = { patientId: this.patientId, doctor: this.doctor };
    await SetPatientDoctor(payload);
    return true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/setDoctor.vue